var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoWidget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0542 23.0791H14.3667C13.6204 23.0791 12.9051 23.3754 12.3773 23.9032C11.8504 24.43 11.5542 25.1454 11.5542 25.8916V31.5166H49.0542V23.0791Z",
    fill: "#BFC5CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5542 26.5342H49.0542V28.2807H11.5542V26.5342Z",
    fill: "#BFC5CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0541 22.2148C49.0541 21.4695 48.7578 20.7542 48.23 20.2264C47.7022 19.6995 46.9869 19.4023 46.2416 19.4023C42.8844 19.4023 37.3541 19.4023 34.3934 19.4023C33.1869 19.4023 32.1153 20.172 31.7291 21.3148C31.1872 22.9208 30.5 24.9533 30.5 24.9533H49.0541V22.2148Z",
    fill: "#87909C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3867 32.095C51.5555 31.0132 51.2424 29.9107 50.5299 29.0782C49.8174 28.2457 48.7767 27.7666 47.6808 27.7666C39.4111 27.7666 21.5892 27.7666 13.3196 27.7666C12.2236 27.7666 11.183 28.2457 10.4705 29.0782C9.758 29.9107 9.44487 31.0132 9.61362 32.095C10.568 38.2 12.2855 49.1932 13.1292 54.595C13.4152 56.4213 14.9874 57.7666 16.8352 57.7666H44.1652C46.013 57.7666 47.5852 56.4213 47.8711 54.595C48.7149 49.1932 50.4324 38.2 51.3867 32.095Z",
    fill: "#D2D6DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61362 32.095L10.0946 35.17C9.92487 34.0872 10.2971 32.9847 11.0096 32.1522C11.7221 31.3197 12.7627 30.8407 13.8586 30.8407H47.1417C48.2377 30.8407 49.2783 31.3197 49.9908 32.1522C50.7033 32.9847 51.0755 34.0872 50.9058 35.17L51.3867 32.095C51.5555 31.0132 51.2424 29.9107 50.5299 29.0782C49.8174 28.2457 48.7767 27.7666 47.6808 27.7666C39.4111 27.7666 21.5892 27.7666 13.3196 27.7666C12.2236 27.7666 11.183 28.2457 10.4705 29.0782C9.758 29.9107 9.44487 31.0132 9.61362 32.095Z",
    fill: "#E4E8EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3579 50.123C28.3579 49.088 27.5188 48.248 26.4829 48.248C24.4026 48.248 21.0642 48.248 18.9829 48.248C17.9479 48.248 17.1079 49.088 17.1079 50.123V51.998C17.1079 53.034 17.9479 53.873 18.9829 53.873H26.4829C27.5188 53.873 28.3579 53.034 28.3579 51.998C28.3579 51.3952 28.3579 50.7268 28.3579 50.123Z",
    fill: "#FCFCFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.585 24.2124C22.5437 23.948 22.5241 23.6874 22.525 23.4305C22.5269 22.914 22.1087 22.4921 21.5912 22.4893C21.0737 22.4874 20.6519 22.9055 20.65 23.423C20.6481 23.7774 20.6753 24.1383 20.7334 24.5039C20.8131 25.0149 21.2941 25.3646 21.805 25.284C22.3159 25.2043 22.6656 24.7233 22.585 24.2124Z",
    fill: "#E4E8EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5694 20.6188C23.7531 20.4031 23.9594 20.2006 24.1881 20.0113C24.5865 19.6813 24.6428 19.0906 24.3128 18.6913C23.9828 18.2928 23.3922 18.2366 22.9928 18.5666C22.6787 18.8263 22.3947 19.1066 22.1415 19.4028C21.8059 19.7975 21.8537 20.3891 22.2475 20.7247C22.6412 21.0603 23.2337 21.0125 23.5694 20.6188Z",
    fill: "#E4E8EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1028 18.6583C27.4815 18.573 27.8809 18.5092 28.2999 18.467C28.8146 18.4155 29.1906 17.9561 29.139 17.4414C29.0874 16.9267 28.6281 16.5498 28.1134 16.6014C27.6165 16.6511 27.1421 16.728 26.6921 16.8292C26.1868 16.9426 25.869 17.4442 25.9824 17.9486C26.0959 18.4539 26.5974 18.7717 27.1028 18.6583Z",
    fill: "#E4E8EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9017 18.4633C32.4736 18.4783 33.0164 18.4736 33.5339 18.4521C34.0505 18.4305 34.4527 17.9927 34.4311 17.4761C34.4095 16.9596 33.9727 16.5574 33.4552 16.579C32.978 16.5986 32.4764 16.6024 31.9495 16.5893C31.432 16.5761 31.0017 16.9858 30.9886 17.5024C30.9755 18.0199 31.3851 18.4502 31.9017 18.4633Z",
    fill: "#E4E8EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.408 17.8645C38.0127 17.6892 38.5583 17.4801 39.0477 17.2457C39.5136 17.0217 39.7105 16.4611 39.4864 15.9942C39.2624 15.5282 38.7017 15.3314 38.2358 15.5554C37.8327 15.7486 37.3836 15.9192 36.8849 16.0645C36.388 16.2089 36.102 16.7292 36.2464 17.2261C36.3908 17.7229 36.9111 18.0089 37.408 17.8645Z",
    fill: "#E4E8EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8647 14.9437C42.3128 14.3043 42.6053 13.6227 42.7665 12.9337C42.8847 12.4293 42.5706 11.9249 42.0672 11.8068C41.5637 11.6896 41.0584 12.0027 40.9412 12.5062C40.8316 12.9731 40.6328 13.4343 40.3291 13.8674C40.0328 14.2912 40.135 14.8762 40.5587 15.1734C40.9825 15.4706 41.5684 15.3674 41.8647 14.9437Z",
    fill: "#E4E8EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4208 9.17201C42.0055 8.20357 41.3549 7.38794 40.5824 6.85544C40.1558 6.56107 39.5717 6.66888 39.2783 7.09451C38.9839 7.52013 39.0917 8.10513 39.5174 8.39857C40.0189 8.74451 40.4286 9.28357 40.6977 9.91169C40.902 10.3879 41.4542 10.6083 41.9295 10.4039C42.4049 10.1995 42.6252 9.64826 42.4208 9.17201Z",
    fill: "#E4E8EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3979 6.40436C31.4123 0.660302 40.2033 1.03155 35.0854 6.40436H30.3979Z",
    fill: "#D2D6DC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3979 7.85938C31.4123 13.6025 40.2033 13.2322 35.0854 7.85938H30.3979Z",
    fill: "#D2D6DC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3135 8.0791H36.591C37.1085 8.0791 37.5285 7.6591 37.5285 7.1416C37.5285 6.6241 37.1085 6.2041 36.591 6.2041H30.3135C29.7969 6.2041 29.376 6.6241 29.376 7.1416C29.376 7.6591 29.7969 8.0791 30.3135 8.0791Z",
    fill: "#E4E8EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWidget);
export default __webpack_public_path__ + "static/media/NoWidget.0870c28577644b62dd19d5900ee6390f.svg";
export { ForwardRef as ReactComponent };